import { ExclamationCircleFilled, SearchOutlined } from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Col,
  Dropdown,
  Form,
  Input,
  Menu,
  message,
  Modal,
  notification,
  Row,
  Select,
  Space,
  Tooltip,
} from 'antd'
import React, {
  forwardRef,
  ReactElement,
  useContext,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { RootDispatch } from '../../../app/store'
import { EditableList } from '../../../compnents/list/EditableList'
import { selectMenus, traceRoute } from '../../../layouts/layoutSlice'
import { Dimen } from '../../../models/dimen'
import {
  Patient,
} from '../../../models/patient'
import {
  getSourceTypeName,
} from '../../../models/registration'
import { getGenderName } from '../../../models/user'
import { GetPatientListParams } from '../../../services/patient'
import { ThemeContext } from '../../../theme/ThemeContext'
import { getAge } from '../../../utils/StringUtils'
import { removePatientAsync } from '../../A-toothModule/patient/patientSlice'
import { QrCodeModal } from '../../A-toothModule/toothHome/modal/qrCodeModal'
import { setPatientPageId } from '../../registration/register/registerSlice'
import { MergePatientModal } from './mergePatientModal'
import { PurchaseModal } from './patientImportModal'
import {
  getPatientLabels,
  getPatientList,
  getPatientListExportAsync,
  selectPatientPage,
  setExportloading,
} from './patientListSlice'
import { PatientCreateModal } from './patientCreateModal'
import { decrypt } from '../../../models/m'
import styles from './mergePatientModal.module.css'
import { SendMessageModal } from '../../A-toothModule/toothHome/modal/sendMessageModal'
import { getPatientOptionsAsync, setSendIDs } from '../../A-toothModule/toothHome/toothHomeSlice'
import { DateRangeGH, DateRangeType, DateSelect } from "../../../compnents/form/DateSelect";
import { getPatientDetail } from '../patientSlice'
import { PatientModal } from '../modals/PatientModal'
import { selectRole } from '../../../app/applicationSlice'
import { getCheckPermissionAsync } from '../../FunctionSetting/dataPermission/dataPermissionSlice'
import { SJQXChecks } from '../../../models/dataPersion'
import { getMaskPhone } from '../../../models/phone'
interface PatientsProps {
  state: string,
}

export interface PatientsRef {
  outClude: () => void
}

 const PatientLists = (
   { state }: PatientsProps,
   ref: React.Ref<PatientsRef>
 ): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const inputRef = useRef<any>(null)

  const history = useHistory()

  const theme = useContext(ThemeContext)

  const [form] = Form.useForm()

  const { Option } = Select

  const page = useSelector(selectPatientPage)

  const role = useSelector(selectRole)

  const [selectionType] = useState<'checkbox' | 'radio'>('checkbox')

  const [pageLoading, setPageLoading] = useState(false) // 表格 loading

  const storageKey = location.pathname + '_patientList'
  
  const storageParams = JSON.parse(sessionStorage.getItem(storageKey) || '{}')
  
  const hasStorageParams = Object.keys(storageParams).length > 0

  const [params, setParams] = useState<GetPatientListParams>(hasStorageParams ? storageParams : { current: 1 })

  const [labelList, setLabelList] = useState<any>([])

  const [selectIds, setSelectIds] = useState<any>([])

  const [sendMsgObj, setSendMsgObj] = useState<any>(null)

  const [sendMessageModalVisible, setSendMessageModal] = useState(false) // 发送短信弹窗

  const [mergePatientVisible, setMergePatientVisible] = useState(false)

  const [patientId, setPatientId] = useState('')

  const [qrCodeModal, setQrCodeModal] = useState(false) //二维码弹窗

  const [isPurchaseModalVisible, setIsPurchaseModalVisible] = useState(false) // 控制导入弹窗是否显示

  const [purchaseModalState, setPurchaseModalState] = useState<number>() //模板弹窗导入模板控制

  const [isCreateModalVisible, setIsCreateModalVisible] = useState(false)

  const allMenus = useSelector(selectMenus)

  const YYFlag = allMenus?.filter((v: any) => v?.id == 115)?.length

  const [patient, setPatient] = useState<any>()

  const [isPatientModalVisible, setIsPatientModalVisible] = useState(false)

  const [classificationList, setClassificationList] = useState<any>() //自定义患者来源数据

  const [HZGLCKHZSJHData, setHZGLCKHZSJHData] = useState(true)
  
  // 获取患者管理查看患者手机号数据权限
  const getCheckPermissionFn = () => {
    dispatch(getCheckPermissionAsync({ itemCode: SJQXChecks.HZGLCKHZSJH }))
      .then(unwrapResult)
      .then((res: any) => {
        setHZGLCKHZSJHData(res)
      })
  }
    
   // 恢复表单搜索条件
   useEffect(() => {
     if (hasStorageParams) {
       form.setFieldsValue({
         ...storageParams,
         labelIds: storageParams.labelIds ? storageParams.labelIds?.split(',') || [] : []
       })
     }
   }, [])

  useEffect(() => {
    if (state == '0')
      getCheckPermissionFn()
  }, [state])
  
  const [sortedInfo, setSortedInfo] = useState<any>({}) // 排序状态

  useImperativeHandle(ref, () => ({
    outClude: () => {
      outCluedExport()
    },
  }))
  useEffect(() => {
    sessionStorage.setItem(location.pathname, JSON.stringify({ state }))
  }, [state])

  const getPage = () => {
    // 兼容 columnKey 和 field
    const sortField = sortedInfo?.columnKey || sortedInfo?.field
    const sortOrder = sortedInfo?.order
    
    // 根据排序方向确定排序值：升序=0，降序=1，取消排序=undefined
    const getSortValue = (field: string) => {
      if (sortField !== field) return undefined
      if (sortOrder === 'ascend') return 0
      if (sortOrder === 'descend') return 1
      return undefined // 取消排序
    }
    
    setPageLoading(true)
    dispatch(
      getPatientList({
        ...params,
        labelName: params.labelName ? params.labelName : undefined,
        // 添加排序参数
        nameSort: getSortValue('name'),
        idSort: getSortValue('id'),
        sexSort: getSortValue('sex'),
        ageYearSort: getSortValue('ageYear'),
        patientSourceSort: getSortValue('patientSource'),
        totalPayAmountSort: getSortValue('totalPayAmount'),
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        if (params.name?.length == 9 && res.items.length == 1) {
          // 1112  不做跳转
          // navigateTo(res.items[0])
        }
      })
      .finally(() => setPageLoading(false))
  }
  useEffect(() => {
    getPage()
    sessionStorage.setItem(storageKey, JSON.stringify(params))
  }, [dispatch, params, sortedInfo])

  useEffect(() => {
    dispatch(getPatientLabels({ current: 1, size: 50 }))
      .then(unwrapResult)
      .then((res: any) => {
        setLabelList(res)
      })
    inputRef.current!.focus({
      cursor: 'start',
    })
  }, [])

  const navigateTo = (patient: Patient) => {
    dispatch(
      traceRoute({
        name: '门诊统计',
        path: '/patient/detail',
        query: `patientId=${patient.id}`,
      })
    )
  }

  const menu = (p: any) => (
    <Menu>
      <Menu.Item
        onClick={() => {
          setMergePatientVisible(true)
          setPatientId(p.id)
        }}
      >
        合并患者
      </Menu.Item>
      <Menu.Item
        onClick={() => {
          Modal.confirm({
            centered: true,
            title: '确认操作',
            content: (
              <div>
                <ExclamationCircleFilled
                  style={{ color: '#FFAE55', fontSize: 18 }}
                />
                &nbsp;您确定删除 [{p?.name}] 患者吗？
              </div>
            ),
            okText: '确认',
            cancelText: '取消',
            icon: null,
            onOk: () => {
              dispatch(
                removePatientAsync({
                  ids: p?.id.toString(),
                })
              )
                .then(unwrapResult)
                .then(() => {
                  notification.success({
                    message: '删除成功',
                  })
                  setParams({
                    ...params,
                    current: 1,
                    size: 10,
                  })
                  getPage()
                })
            },
          })
        }}
      >
        删除
      </Menu.Item>
    </Menu>
  )

  const importTemplateFn = (state: number) => {
    // 导入模板
    setPurchaseModalState(state)
    setIsPurchaseModalVisible(true)
  }

  const exportExcel = () => {
    const theader = [
      '患者姓名',
      '病历号',
      '性别',
      '年龄',
      '身份证',
      '联系电话',
      '患者来源',
      '标签',
      '消费金额',
    ]

    const filterVal = [
      'name',
      'id',
      'sex',
      'ageYear',
      'idCardNumber',
      'phone',
      'patientSource',
      'labelVo',
      'totalPayAmount',
    ]

    dispatch(
      getPatientList({
        ...params,
        labelName: params.labelName ? params.labelName : undefined,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        const data = res?.items
          ?.map((item: any) => {
            return {
              ...item,
              patientName: item?.patientName ? item?.patientName : '-',
              id: item?.id > -1 ? item?.id : '-',
              sex: item?.sex ? getGenderName(item.sex) : '-',
              ageYear: getAge(item?.ageYear, item?.ageMonth),
              idCardNumber: item?.idCardNumber ? item?.idCardNumber : '-',
              phone: (item?.phone ? decrypt(item?.phone) : '-'),
              patientSource: item?.patientSource || '-',
              labelVo: item?.labelVo?.length
                ? item?.labelVo?.map((v: any) => {
                  return v?.headName
                })
                : '-',
              totalPayAmount: item?.totalPayAmount ? item?.totalPayAmount : '0',
            }
          })
          ?.map((s: any) => filterVal?.map((j: any) => s[j]))
        const datas = res?.items?.slice(0, 500)?.map((item: any) => {
          return {
            ...item,
            patientName: item?.patientName ? item?.patientName : '-',
            id: item?.id > -1 ? item?.id : '-',
            sex: item?.sex ? getGenderName(item.sex) : '-',
            ageYear: getAge(item?.ageYear, item?.ageMonth),
            idCardNumber: item?.idCardNumber ? item?.idCardNumber : '-',
            phone:(item?.phone ? decrypt(item?.phone): '-'),
            patientSource: item?.patientSource || '-',
            labelVo: item?.labelVo?.length
              ? item?.labelVo?.map((v: any) => {
                  return v?.headName
                })
              : '-',
            totalPayAmount: item?.totalPayAmount ? item?.totalPayAmount : '0',
          }
        })

        const exportData =
          res?.items?.length >= 500
            ? datas?.map((s: any) => filterVal?.map((j: any) => s[j]))
            : data
        import('../../../ExportXLSX/Export2Excel').then((excel) => {
          excel.export_json_to_excel({
            header: theader,
            data: exportData,
            filename: '患者管理',
            autoWidth: true,
            bookType: 'xlsx',
          })
        })
        if (res?.items?.length >= 500) {
          message.info('最多可导出500条')
        }
        setParams({
          ...params,
          current: 1,
          size: 10,
        })
      })
  }

  const disable = (callback: () => void) => {
    if (selectIds.length == 0) {
      notification.info({
        message: '请先选择患者',
      })
      return
    }
    callback()
  }

  useEffect(() => { 
    dispatch(getPatientOptionsAsync({ types: '0,1,2' }))
      .then(unwrapResult)
      .then((res: any) => {
        const findItems = (type: string) => {
          return res ? res?.find((t: any) => t.type == type)?.items?.map((v: any) => {
            return {
              name: v.context,
              value: v.sortNo,
            }
          }) : []
        }
        setClassificationList({
          sourceList: findItems('1'),
        })
      })
  }, [])

  const outCluedExport = () => {
    dispatch(setExportloading(true))
    dispatch(getPatientListExportAsync({
      ...params,
      labelName: params.labelName ? params.labelName : undefined,
    }))
      .then(unwrapResult)
      .then((res: any) => {
        const content = res
        const blob = new Blob([content])
        const fileName = '患者管理.xlsx'
        const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
        const elink = document.createElement('a')
        if ('download' in elink) {
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = selfURL['createObjectURL'](blob)
          document.body.appendChild(elink)
          // 触发链接
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          return (navigator as any).msSaveBlob(blob, fileName)
        }
      })
      .then(() => {
        notification.success({
          message: '导出成功',
          duration: 3,
        })
      })
      .catch((res: any) => {
        notification.success({
          message: '导出失败',
          duration: 3,
        })
      })
      .finally(() => {
       dispatch(setExportloading(false))
      })
  }

  return (
    <Col
      style={{
        marginTop: 10,
        padding: '20px 15px',
        height: 'calc(100% - 10px)',
        borderRadius: theme.br,
        backgroundColor: theme.pn,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Form
        form={form}
        autoComplete='off'
        onFinish={(values) => {
          if(!values?.settlementTimeHead && values?._dateRange == 6){
            return
          }
          setParams({
            ...params,
            ...values,
            labelIds: values?.labelIds?.toString(),
            current: 1,
          })
        }}
      >
        <Row
          style={{ marginBottom: 10 }}
          align='middle'
          justify='space-between'
        >
          <Space>
            <Form.Item name='name' noStyle>
              <Input
                ref={inputRef}
                allowClear
                style={{ width: 315 }}
                onChange={form.submit}
                placeholder='请输入姓名/手机号/助记码/病历号'
                prefix={<SearchOutlined style={{ color: theme.tc3 }} />}
              />
            </Form.Item>
            <Form.Item name='labelIds' noStyle>
              <Select
                showSearch
                placeholder='标签选择'
                optionFilterProp='children'
                style={{ width: 180 }}
                mode='multiple'
                onChange={form.submit}
                onSearch={(v) => {
                  dispatch(getPatientLabels({ current: 1, size: 50, name: v }))
                    .then(unwrapResult)
                    .then((res: any) => {
                      setLabelList(res)
                    })
                }}
                filterOption={false}
              >
                {labelList.length &&
                  labelList.map((v: any) => (
                    <Option key={v.id} value={v.id}>
                      {v.name}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
            <Form.Item name='patientSource' noStyle>
              <Select
                allowClear
                placeholder='患者来源'
                style={{ width: 150 }}
                onChange={form.submit}
              >
                {classificationList?.sourceList.map((v: any) => {
                  return (
                    <Select.Option key={v.name} value={v.name}>
                      {v.name}
                    </Select.Option>
                  )
                })}
              </Select>
            </Form.Item>
            <DateSelect
              style={{ width: '10rem' }}
              labelPrefix=''
              namePrefix='settlementTime'
              placeholder='最近一次结算时间'
              onChange={() => form.submit()}
              options={DateRangeGH}
            />
            <Button type='primary' htmlType='submit' loading={pageLoading}>
              查询
            </Button>
          </Space>
          <Space>
            <Button
              style={{ background: 'rgb(250, 135, 20)', border: '1px solid rgb(250, 135, 20)' }}
              type='primary'
              onClick={() => {
                disable(() => {
                  setSendMsgObj(null)
                  setSendMessageModal(true)
                })
              }}
            >
              发送短信
            </Button>
            <Button type='primary' onClick={() => setIsCreateModalVisible(true)}>
              新增患者
            </Button>
            <Button type='primary' onClick={() => importTemplateFn(1)}>
              患者信息导入
            </Button>
          </Space>
        </Row>
      </Form>
      <EditableList<Patient>
        style={{ flex: 1 }}
        loading={pageLoading}
        page={page}
        columns={[
          {
            title: '序号',
            key: 'no',
            width: Dimen.Num,
            align: 'center',
            render: (_1, _2, i) => `${page.size * (page.current - 1) + i + 1}`,
          },
          {
            title: '患者姓名',
            dataIndex: 'name',
            width: Dimen.Name,
            align: 'center',
            sorter: true,
            sortOrder: (sortedInfo?.columnKey === 'name' || sortedInfo?.field === 'name') ? sortedInfo?.order : null,
            render: function ShowActions(_, p) {
              return (
                <span
                  style={{
                    color: '#027AFF',
                    cursor: 'pointer',
                  }}
                  onClick={(e) => {
                    e.stopPropagation()
                    dispatch(getPatientDetail(p?.id))
                      .then(unwrapResult)
                      .then((pateint: any) => {
                        setPatient(pateint)
                        setIsPatientModalVisible(true)
                      })
                      .catch(() => {
                        // do nothing.
                      })
                  }}
                >
                  {_}
                </span>
              )
            }
          },
          {
            title: '病历号',
            key: 'id',
            width: Dimen.Sex,
            align: 'center',
            dataIndex: 'id',
            sorter: true,
            sortOrder: sortedInfo?.columnKey === 'id' ? sortedInfo?.order : null,
          },
          {
            title: '性别',
            dataIndex: 'sex',
            align: 'center',
            sorter: true,
            sortOrder: (sortedInfo?.columnKey === 'sex' || sortedInfo?.field === 'sex') ? sortedInfo?.order : null,
            render: function ShowActions(_, p) {
              return getGenderName(p.sex)
            },
          },
          {
            title: '年龄',
            dataIndex: 'ageYear',
            align: 'center',
            sorter: true,
            sortOrder: (sortedInfo?.columnKey === 'ageYear' || sortedInfo?.field === 'ageYear') ? sortedInfo?.order : null,
            render: (_, r) => getAge(r?.ageYear, r?.ageMonth),
          },
          {
            title: '身份证',
            dataIndex: 'idCardNumber',
            width: Dimen.IdCardNumber,
            align: 'center',
          },
          {
            title: '联系电话',
            dataIndex: 'phone',
            width: Dimen.TelPhone,
            align: 'center',
            render: (_, r) => {
              return r?.phone ? (!HZGLCKHZSJHData ? getMaskPhone(decrypt(r?.phone)) : decrypt(r?.phone)): '-'
            },
          },
          {
            title: '患者来源',
            dataIndex: 'patientSource',
            align: 'center',
            sorter: true,
            sortOrder: (sortedInfo?.columnKey === 'patientSource' || sortedInfo?.field === 'patientSource') ? sortedInfo?.order : null,
            render: function ShowActions(_, p) {
              // 优先使用 patientSource（字符串类型）
              if (p.patientSource) {
                return p.patientSource;
              }
              // 如果 patientSource 无值，使用 source（数字类型）并通过 getSourceTypeName 转换
              else if (p.source !== undefined && p.source !== null) {
                return getSourceTypeName(p.source);
              }
              // 如果都没有，返回 '-'
              return '-';
            },
          },
          {
            title: '标签',
            dataIndex: 'labelVo',
            width: Dimen.Tag,
            align: 'center',
            render: function element(_, p) {
              return (
                <Space>
                  {!!p.labelVo.length &&
                    p.labelVo.map((v: any) => {
                      return (
                        <Tooltip key={v.id} title={v.name}>
                          <span
                            className={styles.label}
                            style={{ color: `${v.fontColor}`,backgroundColor: `${v.backgroundColor}`, borderRadius: '50%' }}
                          >
                            {v.headName}
                          </span>
                        </Tooltip>
                      )
                    })}
                </Space>
              )
            },
          },
          {
            title: '消费金额',
            dataIndex: 'totalPayAmount',
            width: Dimen.Tag,
            align: 'center',
            sorter: true,
            sortOrder: (sortedInfo?.columnKey === 'totalPayAmount' || sortedInfo?.field === 'totalPayAmount') ? sortedInfo?.order : null,
            render: function ShowActions(_, p) {
              return p.totalPayAmount && p.totalPayAmount.toFixed(2)
            },
          },
          {
            title: '操作',
            key: 'actions',
            width: '8rem',
            align: 'center',
            render: function ShowActions(_, p) {
              return (
                <>
                  <Space>
                    <a
                      onClick={() => {
                        dispatch(setPatientPageId(p.id))
                        dispatch(
                          traceRoute({
                            name: '挂号',
                            path: '/registration',
                          })
                        )
                      }}
                    >
                      挂号
                    </a>
                    {YYFlag == 1 ? (
                      <a
                        onClick={() => {
                          dispatch(setPatientPageId(p.id))
                          dispatch(
                            traceRoute({
                              name: '预约',
                              path: '/addEditAppointment',
                            })
                          )
                        }}
                      >
                        预约
                      </a>
                    ) : (
                      ''
                    )}

                    <a
                      onClick={() => {
                        dispatch(
                          traceRoute({
                            name: '随访',
                            path: '/followUp',
                          })
                        )
                      }}
                    >
                      随访
                    </a>
                    <a
                      onClick={() => {
                        setSelectIds([])
                        dispatch(setSendIDs([]))
                        setSendMsgObj(p)
                        setSendMessageModal(true)
                      }}
                    >
                      短信
                    </a>
                    <Dropdown overlay={menu(p)} trigger={['click']}>
                      <a>更多</a>
                    </Dropdown>

                    {/*<a*/}
                    {/*  onClick={() => {*/}
                    {/*    setQrCodeModal(true)*/}
                    {/*    setPatientId(p.id)*/}
                    {/*  }}*/}
                    {/*>*/}
                    {/*  二维码*/}
                    {/*</a>*/}
                  </Space>
                </>
              )
            },
          },
        ]}
        onChange={(pagination, filters, sorter: any) => {
          setSortedInfo(sorter)
        }}
        onChangePage={(current, size) =>
          setParams({ ...params, current, size })
        }
        onRow={(record) => ({
          onDoubleClick: () => {
            navigateTo(record)
          },
          onClick: () => {
            let data = []
            if (!selectIds.includes(record.id.toString())) {
              data = [record.id.toString(), ...selectIds]
            } else {
              data = selectIds.filter((v:any) => v != record.id.toString())
            }
            setSelectIds(data)
            dispatch(setSendIDs(data))
          },
        })}
        rowSelection={{
          selectedRowKeys: selectIds,
          onSelectAll: (selected: any, selectedRows: any, changeRows: any) => {
            let data: any = []
            if (selected) {
              data = [
                ...changeRows.map((v: any) => v.id.toString()),
                ...selectIds,
              ]
            } else {
              data = selectIds.filter(
                (item:any) =>
                  !changeRows.some((ele: any) => ele.id.toString() === item)
              )
            }
            setSelectIds(data)
            dispatch(setSendIDs(data))
          },
          onSelect: (record, selected, selectedRows) => {
            let data = []
            if (selected) {
              data = [record.id.toString(), ...selectIds]
            } else {
              data = selectIds.filter((v:any) => v != record.id.toString())
            }
            setSelectIds(data)
            dispatch(setSendIDs(data))
          },
        }}
      />
      {/* 二维码 */}
      <QrCodeModal
        visible={qrCodeModal}
        onCancel={() => {
          setQrCodeModal(false)
        }}
        onOk={() => {
          setQrCodeModal(false)
        }}
      />
      <MergePatientModal
        patientId={patientId}
        visible={mergePatientVisible}
        onCancel={() => setMergePatientVisible(false)}
        onOk={() => {
          getPage()
        }}
        type={1}
      />

      <PurchaseModal
        state={purchaseModalState}
        isPurchaseModalVisible={isPurchaseModalVisible}
        onOk={() => {
          setIsPurchaseModalVisible(false)
          getPage()
        }}
        onCancel={() => {
          setIsPurchaseModalVisible(false)
          getPage()
        }}
      />

      <PatientCreateModal 
        visible={isCreateModalVisible} 
        onCancel={() => setIsCreateModalVisible(false)} 
        onOk={() => {
          setIsCreateModalVisible(false)
          getPage()
        }}
      />

      <SendMessageModal
        HZGLCKHZSJHData={HZGLCKHZSJHData}
        sendMsgObj={sendMsgObj}
        visible={sendMessageModalVisible}
        onCancel={() => {
          setSendMsgObj(null)
          setSendMessageModal(false)
          setSelectIds([])
          dispatch(setSendIDs([]))
        }}
        onOk={() => {
          setSendMsgObj(null)
          getPage()
          setSelectIds([])
          dispatch(setSendIDs([]))
        }}
        isBirthday={true}
      />

      <PatientModal
        CKHZSJHData={HZGLCKHZSJHData} //患者管理
        patient={patient}
        visible={isPatientModalVisible}
        onCancel={() => {
          setIsPatientModalVisible(false)
          setPatient({})
        }}
        onOk={() => {
          setPatient({})
          getPage()
          setIsPatientModalVisible(false)
        }}
      />
    </Col>
  )
}

export const Patients = forwardRef(PatientLists)

